
import React from "react";
import { ProgramDetailWrapper } from "./ProgramDetailWrapper";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { AuthCheck } from "@/components/auth/AuthCheck";

interface ProgramDetailNotFoundProps {
  avatarUrl: string;
  name: string;
}

export function ProgramDetailNotFound({ avatarUrl, name }: ProgramDetailNotFoundProps) {
  return (
    <AuthCheck>
      <ProgramDetailWrapper avatarUrl={avatarUrl} name={name}>
        <div className="flex-1 flex items-center justify-center p-6">
          <div className="flex flex-col items-center gap-4 max-w-md text-center">
            <div className="bg-white/10 p-4 rounded-full">
              <ArrowLeft className="h-8 w-8 text-white" />
            </div>
            <h3 className="text-xl font-semibold text-white">Program not found</h3>
            <p className="text-white/70">
              The program you're looking for doesn't exist or you don't have permission to view it.
            </p>
            <Link to="/programs">
              <Button className="mt-4">Back to Programs</Button>
            </Link>
          </div>
        </div>
      </ProgramDetailWrapper>
    </AuthCheck>
  );
}
